<script>
import NavigationWrapper from "@/components/NavigationWrapper";
import AlertEvents from "@/components/AlertEvents";
import AlertHeatmap from "@/components/AlertHeatmap";

export default {
  // Included components
  components: {
    NavigationWrapper,
    AlertEvents,
    AlertHeatmap,
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/alerts">Alerts</b-breadcrumb-item>
      <b-breadcrumb-item to="/alerts/events" active>Events</b-breadcrumb-item>
    </template>
    <h1 class="mb-3">Monitoring</h1>
    <AlertHeatmap class="mb-3"></AlertHeatmap>
    <AlertEvents></AlertEvents>
  </NavigationWrapper>
</template>

<style scoped></style>
